import React from 'react'
import PropTypes from 'prop-types'
import { MODAL_TYPE, SL_GATE, SL_FORM_TITLE } from 'Defaults/modals'

// import css from './styles.js'
import { _ListingLockCard, _CardTitle, _Buttons, _AppButtonCta } from './styles'

const ListingLockCard = ({ openModal, modalSource }) => (
  <_ListingLockCard>
    <_CardTitle>Log in or Sign up to {SL_FORM_TITLE[SL_GATE.LISTING_CARD_IMAGE]}</_CardTitle>
    <_Buttons>
      <_AppButtonCta
        secondary
        medium
        onClick={
          () => openModal({
            modalType: MODAL_TYPE.LOGIN,
            modalSource,
            modalData: { gate: SL_GATE.LISTING_IMAGE },
          })
        }
        isLoginStyle
      >
        Log in
      </_AppButtonCta>
      <_AppButtonCta
        primary
        medium
        onClick={
          () => openModal({
            modalType: MODAL_TYPE.REGISTER,
            modalSource,
            modalData: { gate: SL_GATE.LISTING_IMAGE },
          })
        }
      >
        Sign up
      </_AppButtonCta>
    </_Buttons>
  </_ListingLockCard>
)


export default ListingLockCard

ListingLockCard.propTypes = {
  openModal: PropTypes.func,
  modalSource: PropTypes.string,
}
